<template>
  <label
    ref="labelRef"
    :for="id"
    class="collapse-title"
    tabindex="0"
    @keydown.enter.prevent="handleKeyboardTrigger"
    @keydown.space.prevent="handleKeyboardTrigger"
  >
    <slot />
  </label>
</template>

<script lang="ts" setup>
const id = inject<string>('collapse-id')

const labelRef = ref<HTMLLabelElement | null>(null)

const handleKeyboardTrigger = () => {
  if (labelRef.value == null) {
    return
  }

  labelRef.value.click()

  // Workaround to trigger the focus-visible effect
  labelRef.value.contentEditable = 'true'
  labelRef.value.focus()
  labelRef.value.contentEditable = 'false'
}
</script>
